import { Entity } from "game-common/models"
import { AnimationPoseView, sampleAnimationPose } from "game-common/animation_pose"
import { radians_to_cardinal_dir } from "game-common/util"

export interface BodyAnimationPose {
    action: string
    progress: number
    frame?: number
}

/** Any body can hold or release a pose. No NPC, weapon, target or campaign assumptions. */
export class AnimationPoseDriver {
    private view?: AnimationPoseView
    private receivedAt = 0
    update = (entity: Entity, now: number): BodyAnimationPose | undefined => {
        if (entity.hp <= 0 || entity.isDead() || !entity.animationPose) { this.view = undefined; return undefined }
        if (entity.animationPose !== this.view) this.receivedAt = now
        this.view = entity.animationPose
        const sampled = sampleAnimationPose(this.view, now - this.receivedAt)
        const directional = ["walk", "idle", "cast", "slash", "thrust", "shoot"].includes(sampled.action)
        return { ...sampled, action: directional ?
            `${sampled.action}-${radians_to_cardinal_dir(this.view.angle)}` : sampled.action }
    }
}
